import { render, staticRenderFns } from "./OtpLoginForm.vue?vue&type=template&id=320317cd&scoped=true"
import script from "./OtpLoginForm.vue?vue&type=script&lang=js"
export * from "./OtpLoginForm.vue?vue&type=script&lang=js"
import style0 from "./OtpLoginForm.vue?vue&type=style&index=0&id=320317cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320317cd",
  null
  
)

export default component.exports